<app-page title="System Approvals">
    <div actionButtons class="flex align-items-center flex-1">
        <!-- Quick Filters -->
        <div class="flex align-items-center gap-2 p-2 surface-ground border-round ml-6 mr-auto">
            <span class="text-sm font-medium text-color-secondary">Quick Filters:</span>

            <!-- State Filters -->
            <div class="flex gap-1">
                <button type="button" class="quick-filter-btn"
                    [class.active]="activeStateFilter() === 'Final'"
                    (click)="filterByState('Final')"
                    pTooltip="Final approval" tooltipPosition="top">
                    Final
                </button>
                <button type="button" class="quick-filter-btn"
                    [class.active]="activeStateFilter() === 'Provisional'"
                    (click)="filterByState('Provisional')"
                    pTooltip="Provisional approval" tooltipPosition="top">
                    Provisional
                </button>
                <button type="button" class="quick-filter-btn"
                    [class.active]="activeStateFilter() === 'Interim'"
                    (click)="filterByState('Interim')"
                    pTooltip="Interim approval" tooltipPosition="top">
                    Interim
                </button>
                <button type="button" class="quick-filter-btn"
                    [class.active]="activeStateFilter() === 'Cancelled'"
                    (click)="filterByState('Cancelled')"
                    pTooltip="Cancelled systems" tooltipPosition="top">
                    Cancelled
                </button>
            </div>

            <span class="text-color-secondary">|</span>

            <!-- System Type Filters -->
            <div class="flex gap-1">
                <button type="button" class="quick-filter-btn"
                    [class.active]="activeSystemTypeFilter() === 'Pretreatment'"
                    (click)="filterBySystemType('Pretreatment')"
                    pTooltip="Chemical Pretreatment Systems (incl. etched & anodised)" tooltipPosition="top">
                    Pretreatment
                </button>
                <button type="button" class="quick-filter-btn"
                    [class.active]="activeSystemTypeFilter() === 'Powder'"
                    (click)="filterBySystemType('Powder')"
                    pTooltip="Coating & Powder Systems" tooltipPosition="top">
                    Powder
                </button>
            </div>

            <!-- Clear All Button -->
            @if (hasActiveFilters()) {
                <button type="button" class="clear-filter-btn"
                    (click)="clearAllQuickFilters()"
                    pTooltip="Clear all quick filters" tooltipPosition="top">
                    <fa-icon [icon]="['fas', 'times']" size="sm"></fa-icon>
                </button>
            }
        </div>

        <!-- Reset Button -->
        <p-button
            (onClick)="resetTableState()"
            severity="secondary"
            pTooltip="Reset filters"
            tooltipPosition="top"
            [text]="true"
            data-testid="reset-all-filters">
            <fa-icon [icon]="['fas', 'rotate-left']" size="lg" transform="rotate-90"></fa-icon>
        </p-button>

        <!-- Actions Menu -->
        @if (hasVisibleActions()) {
            <app-actions-menu
                [items]="actionMenuItems()"
                tooltip="Actions"
                tooltipPosition="top"
                testId="approved-systems-actions-menu"
                class="ml-2">
            </app-actions-menu>
        }
    </div>
    @if (initialGridState) {
    <ag-grid-angular
        class="ag-theme-quartz ag-grid-table"
        [initialState]="initialGridState"
        [gridOptions]="gridOptions"
        [columnDefs]="colDefs"
        [rowSelection]="rowSelection"
        (gridReady)="onGridReady($event)"
        (firstDataRendered)="onFirstDataRendered($event)"
        (stateUpdated)="stateUpdated($event)"
        (columnVisible)="adjustColumnSizes()"
        (toolPanelVisibleChanged)="adjustColumnSizes()"
        (cellClicked)="onCellClicked($event)"
    >
    </ag-grid-angular>
    }
</app-page>
